import { Card } from "@/components/ui/card";
import { Check, Clock, Droplet, Zap } from "lucide-react";
import { Link } from "react-router-dom";

type ReadingCardProps = {
  id: string;
  house: string;
  type: 'water' | 'electricity';
  reading: number;
  status: string;
  date: string;
}

const ReadingCard = ({ id, house, type, reading, status, date }: ReadingCardProps) => {
  const formattedReading = type === 'electricity' ? `${reading} kWh` : `${reading} m³`;

  return (
    <Link to={`/readings/${id}`} className="block w-full overflow-hidden">
      <Card className="p-4 hover:shadow-md transition-all h-[88px] flex items-center bg-white">
        <div className="flex items-center justify-between w-full gap-2 md:gap-4">
          <div className="flex items-center space-x-2 md:space-x-4 flex-1 min-w-0">
            {type === 'water' ? (
              <div className="bg-blue-50 p-2 rounded-lg">
                <Droplet className="w-5 h-5 text-blue-500 flex-shrink-0" />
              </div>
            ) : (
              <div className="bg-yellow-50 p-2 rounded-lg">
                <Zap className="w-5 h-5 text-yellow-500 flex-shrink-0" />
              </div>
            )}
            <div className="min-w-0 flex-1">
              <h3 className="font-semibold truncate text-gray-900">{house}</h3>
              <p className="text-sm text-gray-500 truncate">{date}</p>
            </div>
          </div>
          <div className="flex items-center gap-2 md:gap-4 flex-shrink-0">
            <p className="text-sm text-gray-600 whitespace-nowrap">{formattedReading}</p>
            <div className={`p-2 rounded-full flex-shrink-0 ${
              status === 'completed' 
                ? 'bg-green-50 text-green-600' 
                : 'bg-orange-50 text-orange-600'
            }`}>
              {status === 'completed' ? <Check className="w-4 h-4" /> : <Clock className="w-4 h-4" />}
            </div>
          </div>
        </div>
      </Card>
    </Link>
  );
};

export default ReadingCard;